/** @format */

import Layout from 'components/layout'
import Theme from 'components/template/Theme'
import appConfig from 'configs/app.config'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import history from './history'
import './locales'
import store, { persistor } from './store'
import ErrorBoundary from 'components/ErrorBoundary'
import { NotificationProvider } from 'contexts/NotificationContext'
import { UploadDocIAProvider } from 'contexts/UploadDocumentsIAContext'

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */

const queryClient = new QueryClient()

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <NotificationProvider>
            <UploadDocIAProvider>
              <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                  <Theme>
                    <Layout />
                  </Theme>
                </BrowserRouter>
              </PersistGate>
              {appConfig.ambient === 'dev' && (
                <ReactQueryDevtools
                  initialIsOpen={false}
                  position="bottom-right"
                />
              )}
            </UploadDocIAProvider>
          </NotificationProvider>
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
